import React, { Component } from "react";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";

// Services
import ispService from '@services/isp';
import sobrecustoBiocombustivelService from '@services/sobrecustoBiocombustivel';
import reducaoIspService from '@services/reducaoIsp';
import apolloService from '@services/apollo';

import EditableTable from '@components/EditableTable'
import Input from "@components/Input";
import Button from "@components/Button";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import EmpresaSelect from "@components/EmpresaSelect";

// Components
import Menu from "@components/Menu";

import UserContext from '@components/context/userContext';

import { NotificationManager } from 'react-notifications';

class Page extends Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);

    this.state = {
      reducao_isp: '',
      isps: [],
      biofuels: [],
      loading: false,
    };
    this.loadFunction = this.loadFunction.bind(this);
    this.onTableIspSubmit = this.onTableIspSubmit.bind(this);
    this.onTableBiofuelSubmit = this.onTableBiofuelSubmit.bind(this);
    this.onTableIspChange = this.onTableIspChange.bind(this);
    this.onTableBiofuelChange = this.onTableBiofuelChange.bind(this);
    this.uploadFunction = this.uploadFunction.bind(this);
    this.internalHandleChange = this.internalHandleChange.bind(this);
    this.internalHandleBlur = this.internalHandleBlur.bind(this);
    this.addIspRow = this.addIspRow.bind(this);
    this.deleteIspRow = this.deleteIspRow.bind(this);
    this.addBiofuelRow = this.addBiofuelRow.bind(this);
    this.deleteBiofuelRow = this.deleteBiofuelRow.bind(this);
    this.handleSubmitAll = this.handleSubmitAll.bind(this);
  }

  onTableIspSubmit(id) {
    const profile = this.context;

    this.state.isps.forEach((value) => {
      if (value.id === id) {
        const dataToSend = {
          idempresa: profile.idEmpresaSec,
          codigo: value.codigo,
          taxa_isp: value.taxa_isp,
          descricao_isp: value.descricao_isp,
          motivo_isencao: value.motivo_isencao,
        };

        // For existing rows, include the idisp for UPDATE
        if (!value.isNew && value.idisp) {
          dataToSend.idisp = value.idisp;
        }

        (async () => {
          try {
            await ispService.set(dataToSend);
            // If this was a new row, we need to get the ID from the database
            if (value.isNew) {
              // Fetch the latest data to get the real ID assigned by the database
              const latestData = await ispService.get(profile.idEmpresaSec);
              // Find the row that matches our data (by content, not ID)
              const matchingRow = latestData.find(row => 
                row.codigo === value.codigo && 
                row.taxa_isp === value.taxa_isp && 
                row.descricao_isp === value.descricao_isp && 
                row.motivo_isencao === value.motivo_isencao
              );
              
              if (matchingRow) {
                this.setState(prevState => ({
                  isps: prevState.isps.map(item => 
                    item.id === id 
                      ? { ...item, id: matchingRow.idisp, idisp: matchingRow.idisp, isNew: false }
                      : item
                  )
                }));
              }
            }
          } catch (error) {
            console.error(error);
          }
        })();
      }
    });
  }

  onTableBiofuelSubmit(id) {
    const profile = this.context;

    this.state.biofuels.forEach((value) => {
      if (value.id === id) {
        const dataToSend = {
          idempresa: profile.idEmpresaSec,
          codigo: value.codigo,
          combustivel: value.combustivel,
          descricao: value.descricao,
          energia_fossil: value.energia_fossil,
          energia_renovavel: value.energia_renovavel,
          co2: value.co2,
          un: value.un,
          sobrecusto: value.sobrecusto,
        };

        // For existing rows, include the idsobrecustobiocombustivel for UPDATE
        if (!value.isNew && value.idsobrecustobiocombustivel) {
          dataToSend.idsobrecustobiocombustivel = value.idsobrecustobiocombustivel;
        }

        (async () => {
          try {
            await sobrecustoBiocombustivelService.set(dataToSend);
            // If this was a new row, we need to get the ID from the database
            if (value.isNew) {
              // Fetch the latest data to get the real ID assigned by the database
              const latestData = await sobrecustoBiocombustivelService.get(profile.idEmpresaSec);
              // Find the row that matches our data (by content, not ID)
              const matchingRow = latestData.find(row => 
                row.codigo === value.codigo && 
                row.combustivel === value.combustivel && 
                row.descricao === value.descricao && 
                row.energia_fossil === value.energia_fossil &&
                row.energia_renovavel === value.energia_renovavel &&
                row.co2 === value.co2 &&
                row.un === value.un &&
                row.sobrecusto === value.sobrecusto
              );
              
              if (matchingRow) {
                this.setState(prevState => ({
                  biofuels: prevState.biofuels.map(item => 
                    item.id === id 
                      ? { ...item, id: matchingRow.idsobrecustobiocombustivel, idsobrecustobiocombustivel: matchingRow.idsobrecustobiocombustivel, isNew: false }
                      : item
                  )
                }));
              }
            }
          } catch (error) {
            console.error(error);
          }
        })();
      }
    });
  }

  async loadFunction() {
    if (!this.state.loaded) {
      const profile = this.context;

      try {
        const [reducao_isp, isps, biofuels] = await Promise.all([
          reducaoIspService.get(profile.idEmpresaSec),
          ispService.get(profile.idEmpresaSec),
          sobrecustoBiocombustivelService.get(profile.idEmpresaSec)
        ]);

        this.setState({ 
          reducao_isp: reducao_isp.length > 0 ? reducao_isp[0].reducao_isp : '',
          isps: isps.map((isp) => ({
            ...isp,
            id: isp.idisp,
            isNew: false,
          })),
          biofuels: biofuels.map((biofuel) => ({
            ...biofuel,
            id: biofuel.idsobrecustobiocombustivel,
            isNew: false,
          })),
          loaded: true 
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  onTableIspChange(newValue, row, column) {
    const { isps } = this.state;
    const result = isps.map((value) => {
        if (value.id === row.id) {
            const newRow = { ...value };
            newRow[column.dataField] = newValue;
            return newRow;
        }
        return value;
    });
    this.setState({ isps: result });
    return true;
  }

  onTableBiofuelChange(newValue, row, column) {
    const { biofuels } = this.state;
    const result = biofuels.map((value) => {
        if (value.id === row.id) {
            const newRow = { ...value };
            newRow[column.dataField] = newValue;
            return newRow;
        }
        return value;
    });
    this.setState({ biofuels: result });
    return true;
  }

  uploadFunction() {
    const profile = this.context;

    confirmAlert({
      title: "Confirmação",
      message: `Tem a certeza que deseja enviar todos os impostos para o Apollo?`,
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            apolloService.syncTaxes({
              idempresa: profile.idEmpresaSec,
              isps: this.state.isps,
              biofuels: this.state.biofuels,
              reducao_isp: this.state.reducao_isp,
            })
              .catch((error) => {
                console.error(error);
              });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  internalHandleChange(e) {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
        [name]: value,
    });
  }

  async internalHandleBlur() {
    // Removed auto-submit - now handled by handleSubmitAll
  }

  async handleSubmitAll() {
    const profile = this.context;
    const { isps, biofuels, reducao_isp } = this.state;

    try {
      // Prepare ISP values array
      const ispValues = isps.map((isp) => {
        const dataToSend = {
          codigo: isp.codigo,
          taxa_isp: isp.taxa_isp,
          descricao_isp: isp.descricao_isp,
          motivo_isencao: isp.motivo_isencao,
        };

        // For existing rows, include the idisp for UPDATE
        if (!isp.isNew && isp.idisp) {
          dataToSend.idisp = isp.idisp;
        }

        return dataToSend;
      });

      // Prepare Biofuel values array
      const biofuelValues = biofuels.map((biofuel) => {
        const dataToSend = {
          codigo: biofuel.codigo,
          combustivel: biofuel.combustivel,
          descricao: biofuel.descricao,
          energia_fossil: biofuel.energia_fossil,
          energia_renovavel: biofuel.energia_renovavel,
          co2: biofuel.co2,
          un: biofuel.un,
          sobrecusto: biofuel.sobrecusto,
        };

        // For existing rows, include the idsobrecustobiocombustivel for UPDATE
        if (!biofuel.isNew && biofuel.idsobrecustobiocombustivel) {
          dataToSend.idsobrecustobiocombustivel = biofuel.idsobrecustobiocombustivel;
        }

        return dataToSend;
      });

      // Submit all data
      const promises = [];

      // Submit ISP data
      promises.push(
        ispService.set({
          idempresa: profile.idEmpresaSec,
          values: ispValues,
        })
      );

      // Submit Biofuel data
      promises.push(
        sobrecustoBiocombustivelService.set({
          idempresa: profile.idEmpresaSec,
          values: biofuelValues,
        })
      );

      // Submit Redução ISP
      promises.push(
        reducaoIspService.set({
          idempresa: profile.idEmpresaSec,
          reducao_isp: reducao_isp,
        })
      );

      await Promise.all(promises);

      // Refresh data to get updated IDs for new rows
      const [updatedIsps, updatedBiofuels] = await Promise.all([
        ispService.get(profile.idEmpresaSec),
        sobrecustoBiocombustivelService.get(profile.idEmpresaSec),
      ]);

      // Update state with new IDs for rows that were new
      this.setState((prevState) => {
        const updatedIspsWithIds = prevState.isps.map((isp) => {
          if (isp.isNew) {
            const matchingRow = updatedIsps.find(
              (row) =>
                row.codigo === isp.codigo &&
                row.taxa_isp === isp.taxa_isp &&
                row.descricao_isp === isp.descricao_isp &&
                row.motivo_isencao === isp.motivo_isencao
            );
            if (matchingRow) {
              return {
                ...isp,
                id: matchingRow.idisp,
                idisp: matchingRow.idisp,
                isNew: false,
              };
            }
          }
          return isp;
        });

        const updatedBiofuelsWithIds = prevState.biofuels.map((biofuel) => {
          if (biofuel.isNew) {
            const matchingRow = updatedBiofuels.find(
              (row) =>
                row.codigo === biofuel.codigo &&
                row.combustivel === biofuel.combustivel &&
                row.descricao === biofuel.descricao &&
                row.energia_fossil === biofuel.energia_fossil &&
                row.energia_renovavel === biofuel.energia_renovavel &&
                row.co2 === biofuel.co2 &&
                row.un === biofuel.un &&
                row.sobrecusto === biofuel.sobrecusto
            );
            if (matchingRow) {
              return {
                ...biofuel,
                id: matchingRow.idsobrecustobiocombustivel,
                idsobrecustobiocombustivel: matchingRow.idsobrecustobiocombustivel,
                isNew: false,
              };
            }
          }
          return biofuel;
        });

        return {
          isps: updatedIspsWithIds,
          biofuels: updatedBiofuelsWithIds,
        };
      });

      NotificationManager.success('Dados guardados com sucesso!');
    } catch (error) {
      console.error('Erro ao guardar dados:', error);
      NotificationManager.error('Erro ao guardar dados. Por favor, tente novamente.');
    }
  }

  addIspRow() {
    const newRow = {
      id: `temp_${Date.now()}`,
      codigo: '',
      taxa_isp: '',
      descricao_isp: '',
      motivo_isencao: '',
      isNew: true,
    };
    
    this.setState(prevState => ({
      isps: [...prevState.isps, newRow]
    }));
  }

  deleteIspRow(cell, row) {
    const profile = this.context;

    confirmAlert({
      title: "Confirmação",
      message: `Tem a certeza que deseja eliminar este registo?`,
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            // If it's a row that exists in the database (has idisp), delete from server
            if (!row.isNew && row.idisp) {
              try {
                this.setState(prevState => ({
                  isps: prevState.isps.filter(item => item.id !== row.id)
                }));
              } catch (error) {
                console.error(error);
              }
            } else {
              // For new rows or rows without server ID, just remove from state
              this.setState(prevState => ({
                isps: prevState.isps.filter(item => item.id !== row.id)
              }));
            }
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  addBiofuelRow() {
    const newRow = {
      id: `temp_${Date.now()}`,
      codigo: '',
      combustivel: '',
      descricao: '',
      energia_fossil: '',
      energia_renovavel: '',
      co2: '',
      un: '',
      sobrecusto: '',
      isNew: true,
    };
    
    this.setState(prevState => ({
      biofuels: [...prevState.biofuels, newRow]
    }));
  }

  deleteBiofuelRow(cell, row) {
    const profile = this.context;

    confirmAlert({
      title: "Confirmação",
      message: `Tem a certeza que deseja eliminar este registo?`,
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            // If it's a row that exists in the database (has idsobrecustobiocombustivel), delete from server
            if (!row.isNew && row.idsobrecustobiocombustivel) {
              try {
                this.setState(prevState => ({
                  biofuels: prevState.biofuels.filter(item => item.id !== row.id)
                }));
              } catch (error) {
                console.error(error);
              }
            } else {
              // For new rows or rows without server ID, just remove from state
              this.setState(prevState => ({
                biofuels: prevState.biofuels.filter(item => item.id !== row.id)
              }));
            }
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    const { isps, biofuels, reducao_isp } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);

    return (
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li className="active">Impostos</li>
            </ol>
          </div>
        </div>
        <EmpresaSelect />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-sm-12" style={{ textAlign: "center" }}>
            <div className="panel panel-default">
              <div
                className="panel-heading"
                style={{
                  fontWeight: "bold",
                  fontSize: "15pt",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: '15px'
                }}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  Impostos
                </div>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <table
                    style={{ cursor: "pointer" }}
                    onClick={this.uploadFunction}
                  >
                    <tr>
                      <td>
                        <i className="fas fa-upload"></i>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "xx-small" }}>
                        Enviar Impostos
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div style={{ margin: '30px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <h2 style={{ textAlign: 'left', margin: 0 }}>ISP</h2>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <Button
                      action={this.addIspRow}
                      type={"success"}
                      title={(<><i className="fas fa-plus"></i> Adicionar</>)}
                    />
                  </div>
                </div>
                <EditableTable
                  columns={[
                      {
                        dataField: 'codigo',
                        text: 'Código',
                        editable: true,
                        validator: this.onTableIspChange,
                      }, {
                        dataField: 'taxa_isp',
                        text: 'Taxa ISP',
                        editable: true,
                        validator: this.onTableIspChange,
                      }, {
                        dataField: 'descricao_isp',
                        text: 'Descrição ISP',
                        editable: true,
                        validator: this.onTableIspChange,
                      }, {
                        dataField: 'motivo_isencao',
                        text: 'Motivo Isenção',
                        editable: true,
                        validator: this.onTableIspChange,
                      }, {
                        dataField: 'actions',
                        text: 'Ações',
                        editable: false,
                        formatter: (cell, row) => (
                          <Button
                            action={() => this.deleteIspRow(cell, row)}
                            type={"danger"}
                            title={(<i className="fas fa-trash-alt"></i>)}
                            style={{ padding: '2px 6px', fontSize: '12px' }}
                          />
                        ),
                        headerStyle: { width: '80px' },
                      }
                  ]}
                  data={isps}
                />
              </div>
              <div style={{ margin: '30px' }}>
                <h2 style={{ textAlign: 'left' }}>Redução ISP</h2>
                <Input
                  title={ '' }
                  inputType={"text"}
                  name={"reducao_isp"}
                  value={reducao_isp}
                  handleChange={this.internalHandleChange}
                  onBlur={this.internalHandleBlur}
                  placeholder="redução do isp+IVA gasolinas xxxx gasoleos xxxx"
                />
              </div>
              <div style={{ margin: '30px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                  <h2 style={{ textAlign: 'left', margin: 0 }}>Sobrecusto Biocombustivel</h2>
                  <Button
                    action={this.addBiofuelRow}
                    type={"success"}
                    title={(<><i className="fas fa-plus"></i> Adicionar</>)}
                  />
                </div>
                <EditableTable
                  columns={[
                      {
                        dataField: 'codigo',
                        text: 'Código',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'combustivel',
                        text: 'Combustível',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'descricao',
                        text: 'Descrição',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'energia_fossil',
                        text: 'Energia Fóssil',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'energia_renovavel',
                        text: 'Energia Renovável',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'co2',
                        text: 'CO2',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'un',
                        text: 'UN',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'sobrecusto',
                        text: 'Sobrecusto',
                        editable: true,
                        validator: this.onTableBiofuelChange,
                      }, {
                        dataField: 'actions',
                        text: 'Ações',
                        editable: false,
                        formatter: (cell, row) => (
                          <Button
                            action={() => this.deleteBiofuelRow(cell, row)}
                            type={"danger"}
                            title={(<i className="fas fa-trash-alt"></i>)}
                            style={{ padding: '2px 6px', fontSize: '12px' }}
                          />
                        ),
                        headerStyle: { width: '80px' },
                      }
                  ]}
                  data={biofuels}
                />
                <div style={{ width: '100%', textAlign: 'right' }}>
                  <Button
                    action={this.handleSubmitAll}
                    type={"primary"}
                    title={(<><i className="fas fa-save"></i> Guardar</>)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(withRouter(Page));
